import React from 'react';
import { IconBuilding, IconBriefcase, IconTarget } from '@tabler/icons-react';
import { ModalController } from '@ayocore/platform/client/components/ModalHost/ModalController';
import { CrmExtensions } from './extensions';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';

type CrmModule = ReturnType<AppRuntime['useModule']>;

/**
 * Регистрирует пункты контекстного меню модуля CRM.
 * Вызывается из bootstrap.ts.
 */
export function registerCrmContextMenuItems(crm: CrmModule): void {
  crm.registerContextMenu({
    id: 'create-partner',
    title: 'Создать партнера',
    icon: IconBuilding,
    order: 10,
    onSelect: () => {
      const Form = CrmExtensions.Partners.createForm.get();
      const controller = ModalController.getInstance();
      const id = `ctx-create-partner-${Date.now()}`;
      controller.open(
        id,
        React.createElement(Form, {
          onPartnerCreated: partnerId => {
            controller.close(id);
            if (partnerId)
              void import('@ayocore/platform/client/Router').then(({ router }) =>
                router.navigate(`/crm/partners/${partnerId}`)
              );
          },
        }),
        { title: 'Создать партнера', size: 'lg' },
        []
      );
    },
  });

  crm.registerContextMenu({
    id: 'create-deal',
    title: 'Создать сделку',
    icon: IconBriefcase,
    order: 20,
    onSelect: async () => {
      const { CreateDealForm } = await import('./components/Deals/forms/CreateDealForm');
      const controller = ModalController.getInstance();
      const id = `ctx-create-deal-${Date.now()}`;
      controller.open(
        id,
        React.createElement(CreateDealForm, {
          onDealCreated: deal => {
            controller.close(id);
            if (deal?.id)
              void import('@ayocore/platform/client/Router').then(({ router }) =>
                router.navigate(`/crm/deals/${deal.id}`)
              );
          },
        }),
        { title: 'Создать сделку', size: 'lg' },
        []
      );
    },
  });

  crm.registerContextMenu({
    id: 'create-lead',
    title: 'Создать заявку',
    icon: IconTarget,
    order: 30,
    onSelect: async () => {
      const { CreateLeadForm } = await import('./components/Leads/forms/CreateLeadForm');
      const controller = ModalController.getInstance();
      const id = `ctx-create-lead-${Date.now()}`;
      controller.open(
        id,
        React.createElement(CreateLeadForm, {
          onLeadCreated: leadId => {
            controller.close(id);
            if (leadId)
              void import('@ayocore/platform/client/Router').then(({ router }) =>
                router.navigate(`/crm/leads/${leadId}`)
              );
          },
        }),
        { title: 'Создать заявку', size: 'lg' },
        []
      );
    },
  });
}
